export const GET_ALL_ADMIN_SUCCESS = 'get_all_admins_success';
export const CHANGE_ADMIN_PARAMS = 'change_admins_params';
export const TOGGLE_MODAL = 'toggle_modal';
export const SELECT_ADMIN = 'select_user';
